import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import CountryCodeActions from '../actions/CountryCodeActions';


const CountryCodeSource = {

    getCountryCodes() {
        return {
            remote(state) {
                return new SingleObjectResource(DJ_CONST.API.countrycodeList).fetch();
            },

            success: CountryCodeActions.getCountryCodesSuccess,
            error: CurrentUserActions.pageFault
        }
    },
};

class CountryCodeStore {
    constructor() {
        this.countryCodes = {};
        this.codesLoaded = false;
        this.exportAsync(CountryCodeSource);
        this.bindActions(CountryCodeActions);
    }

    onGetCountryCodesSuccess(countryCodes) {
        this.setState({countryCodes, codesLoaded: true});
    }
}

export default createStore(CountryCodeStore, 'CountryCodeStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/CountryCodeStore.js
 **/